module.exports = __webpack_public_path__ + "img/complate.e9afac49.png";